import imageIdToURI from './imageIdToURI.js';
import { MetadataModules } from '../enums/index.js';
import { clearQuery } from '../metaData.js';
const state = new Map();
const metadataProvider = {
    add: (imageId, payload) => {
        const imageURI = imageIdToURI(imageId);
        state.set(imageURI, payload);
        clearQuery(MetadataModules.IMAGE_PLANE, imageId);
    },
    get: (type, imageId) => {
        if (type === 'calibratedPixelSpacing') {
            const imageURI = imageIdToURI(imageId);
            return state.get(imageURI);
        }
    },
    clear: () => {
        state.clear();
    },
};
export default metadataProvider;
